import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { track } from '../../usage-tracker/track';
import { events } from '../../usage-tracker/events';
import { useCommerceSpecialistsCustomRateAlert } from '../../hooks/useCommerceSpecialistsContact';
import { ExposureLogger, useIsTACQ0006Variant } from 'growth-payments-core/experiment/hooks';
import { TACQ0006 } from 'growth-payments-core/experiment/Ids';
import { TreatmentProvider } from 'growth-payments-core/experiment/utils';
import { useCallback } from 'react';
import GoToProcessorPickerButton from 'payments-enrollment-embed-lib/buttons/GoToProcessorPickerButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CUSTOM_RATE_ALERT_TEST_ID = 'commerce-specialists-custom-rate-alert';
const COMMERCE_SPECIALISTS_CUSTOM_RATE_EMAIL_FORM_URL = 'https://share.hsforms.com/16ih9ZqxlSjOp0rTjqAhc6wbxo5v';
const trackButtonClick = (appName, subAction) => track(events.commerceSpecialistsInteraction, {
  action: 'commerceSpecialistsCustomRateAlertInteraction',
  subAction,
  app: appName
});
const CommerceSpecialistFormButton = ({
  appName
}) => {
  const handleClick = useCallback(() => {
    trackButtonClick(appName, 'customRateButtonClicked');
  }, [appName]);
  return /*#__PURE__*/_jsx(Button, {
    onClick: handleClick,
    use: "tertiary",
    size: "xs",
    href: COMMERCE_SPECIALISTS_CUSTOM_RATE_EMAIL_FORM_URL,
    external: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.commerceSpecialistsCustomRateAlert.ctas.customRate"
    })
  });
};
const CommerceSpecialistsCustomRateAlert = ({
  appName,
  location,
  use,
  condition = () => true
}) => {
  const {
    loading,
    eligible,
    dismissCustomRateAlert
  } = useCommerceSpecialistsCustomRateAlert();
  const isTACQ0006Variant = useIsTACQ0006Variant();
  const handleClose = useCallback(() => {
    track(events.commerceSpecialistsInteraction, {
      action: 'commerceSpecialistsCustomRateAlertInteraction',
      subAction: 'customRateAlertClosed',
      app: appName
    });
    dismissCustomRateAlert();
  }, [dismissCustomRateAlert, appName]);
  if (loading || !eligible || !condition()) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ExposureLogger, {
      experiment: TACQ0006
    }), isTACQ0006Variant && /*#__PURE__*/_jsxs(Alert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CommerceToolsUiLib.commerceSpecialistsCustomRateAlert.title"
      }),
      use: use,
      marginBlockStart: "400",
      closeable: true,
      onClose: handleClose,
      "data-test-id": CUSTOM_RATE_ALERT_TEST_ID,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "CommerceToolsUiLib.commerceSpecialistsCustomRateAlert.description"
      }), /*#__PURE__*/_jsxs(ButtonWrapper, {
        marginBlockStart: "200",
        children: [/*#__PURE__*/_jsx(CommerceSpecialistFormButton, {
          appName: appName
        }), /*#__PURE__*/_jsx(GoToProcessorPickerButton, {
          sourceApp: appName,
          location: location,
          openInCommerceHome: true,
          external: true,
          disableHSPNudge: true,
          use: "tertiary",
          size: "xs",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.commerceSpecialistsCustomRateAlert.ctas.viewPricing"
          })
        })]
      })]
    })]
  });
};
const CommerceSpecialistsCustomRateAlertContainer = props => {
  return /*#__PURE__*/_jsx(TreatmentProvider, {
    children: /*#__PURE__*/_jsx(CommerceSpecialistsCustomRateAlert, Object.assign({}, props))
  });
};
export default CommerceSpecialistsCustomRateAlertContainer;